import { debounce } from "lodash";
import { useCallback } from "react";
import CreateCharacterMpProvider from "@/core/data-provider/data-mp/create-character/create-character-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { FACE, FACE_KEYS } from "@/domains/createCharacter/constants/face";
import { eyeColorSelector, setEyeColor, setFace } from "@/domains/createCharacter/slice";

export default function useChangeFace() {
  const dispatch = useAppDispatch();
  const eyeColor = useAppSelector(eyeColorSelector);

  const onChangeEyeColor = useCallback(
    async (color: number) => {
      await CreateCharacterMpProvider.setEyeColor(color);
      dispatch(setEyeColor(color));
    },
    [dispatch],
  );

  const onChangeFaceFeature = useCallback(
    async (feature: string, value: number) => {
      await CreateCharacterMpProvider.setFace(FACE[feature].id, value);
      dispatch(setFace({ [feature]: value }));
    },
    [dispatch],
  );

  const randomizeAll = useCallback(
    debounce(() => {
      FACE_KEYS.forEach((feature) => {
        onChangeFaceFeature(feature, Math.random());
      });
      onChangeEyeColor(Math.floor(Math.random() * 32));
    }, 50),
    [onChangeFaceFeature, onChangeEyeColor],
  );

  return {
    eyeColor,
    onChangeEyeColor,
    onChangeFaceFeature,
    randomizeAll,
  };
}
